import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import Dialog from '@material-ui/core/Dialog';

import styles from './modal.module.scss';

type Props = React.PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  open: boolean;
  onCloseClickAway?: () => void;
  onClosed?: () => void;
  disableRestoreFocus?: boolean;
  innerProps?: HTMLAttributes<HTMLDivElement>;
  classes?: {
    innerContainer?: string;
    content?: string;
  };
};

export default function Modal({
  open,
  children,
  onCloseClickAway,
  className,
  classes,
  onClosed,
  innerProps,
  ...props
}: Props): JSX.Element {
  return (
    <Dialog
      classes={{ container: classes?.innerContainer }}
      PaperComponent={ModalContent}
      PaperProps={{
        ...innerProps,
        elevation: 0,
        classes: {
          root: classNames(className, innerProps?.className, classes?.content),
        },
      }}
      open={open}
      onClose={onCloseClickAway}
      onExited={onClosed}
      {...props}
    >
      {children}
    </Dialog>
  );
}

function ModalContent({
  children,
  classes,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  classes?: { root?: string };
}): JSX.Element {
  return (
    <div {...props} className={classNames(styles.content, classes?.root)}>
      {children}
    </div>
  );
}
